import Parse from 'html-react-parser';

function BMP20133(props) {
    let svgCode =
    `<svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="28" height="22" fill="${props.darkFill}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15ZM10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 11L27 17L24.2265 21.1603L15.2265 15.1603L18 11Z" fill="white"/>
    </svg>`

    props.svgReturn(60, svgCode, "bmp00133", 28, 22);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20133;